export default "__VITE_ASSET__89908966__"